// --------------------------------------------------------------------------
// Contact Email
// Will update the hidden input (used by Authorize) based on user input
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2017, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {

    var context = options.context;
    var contactEmail = context.find('[data-binding="contact-details-email-address"]');
    var xContactEmail = context.find('input[name="x_email"]');

    function updateEmail() {
        xContactEmail.val(contactEmail.val());
    }

    function init() {
        if (!!contactEmail.length && !!xContactEmail.length) {
            // run on page load
            updateEmail();

            // run on change
            contactEmail.on('change', function () {
                updateEmail();
            });
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/forms/contact-email.js
// module id = 283
// module chunks = 0